import { render, staticRenderFns } from "./BaseToggleIconButton.vue?vue&type=template&id=ef25e66c&scoped=true"
import script from "./BaseToggleIconButton.vue?vue&type=script&lang=js"
export * from "./BaseToggleIconButton.vue?vue&type=script&lang=js"
import style0 from "./BaseToggleIconButton.vue?vue&type=style&index=0&id=ef25e66c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef25e66c",
  null
  
)

export default component.exports